export const HelpMap: Record<string, { path: string; searchKey: string }> = {
  AUDIO_WIDGET: {
    path: "/widget-reference/audio",
    searchKey: "Audio",
  },
  CONTAINER_WIDGET: {
    path: "/widget-reference/container",
    searchKey: "Container",
  },
  CHECKBOX_WIDGET: {
    path: "/widget-reference/checkbox",
    searchKey: "Checkbox",
  },
  BUTTON_WIDGET: {
    path: "/widget-reference/button",
    searchKey: "Button",
  },
  TEXT_WIDGET: {
    path: "/widget-reference/text",
    searchKey: "Text",
  },
  IMAGE_WIDGET: {
    path: "/widget-reference/image",
    searchKey: "Image",
  },
  INPUT_WIDGET: {
    path: "/widget-reference/input",
    searchKey: "Input",
  },
  INPUT_WIDGET_V2: {
    path: "/widget-reference/input",
    searchKey: "Input",
  },
  DATE_PICKER_WIDGET: {
    path: "/widget-reference/datepicker",
    searchKey: "DatePicker",
  },
  DATE_PICKER_WIDGET2: {
    path: "/widget-reference/datepicker",
    searchKey: "DatePicker",
  },
  TABLE_WIDGET: {
    path: "/widget-reference/table",
    searchKey: "Table",
  },
  TABLE_WIDGET_V2: {
    path: "/widget-reference/table",
    searchKey: "Table",
  },
  VIDEO_WIDGET: {
    path: "/widget-reference/video",
    searchKey: "Video",
  },
  DROP_DOWN_WIDGET: {
    path: "/widget-reference/dropdown",
    searchKey: "Select",
  },
  SELECT_WIDGET: {
    path: "/widget-reference/dropdown",
    searchKey: "Select",
  },
  RADIO_GROUP_WIDGET: {
    path: "/widget-reference/radio",
    searchKey: "Radio",
  },
  RICH_TEXT_EDITOR_WIDGET: {
    path: "",
    searchKey: "Rich Text Editor",
  },
  CHART_WIDGET: {
    path: "/widget-reference/chart",
    searchKey: "Chart",
  },
  FORM_WIDGET: {
    path: "/widget-reference/form",
    searchKey: "Form",
  },
  FILE_PICKER_WIDGET: {
    path: "/widget-reference/filepicker",
    searchKey: "File picker",
  },
  FILE_PICKER_WIDGET_V2: {
    path: "/widget-reference/filepicker",
    searchKey: "File picker",
  },
  FORM_BUTTON_WIDGET: {
    path: "",
    searchKey: "",
  },
  CANVAS_WIDGET: {
    path: "",
    searchKey: "",
  },
  ICON_WIDGET: {
    path: "",
    searchKey: "",
  },
  SKELETON_WIDGET: {
    path: "",
    searchKey: "",
  },
  TABS_WIDGET: {
    path: "",
    searchKey: "Tabs",
  },
  TABS_MIGRATOR_WIDGET: {
    path: "",
    searchKey: "",
  },
  MODAL_WIDGET: {
    path: "",
    searchKey: "",
  },
  MAP_WIDGET: {
    path: "",
    searchKey: "Map",
  },
  API_MAIN: {
    path: "/core-concepts/apis",
    searchKey: "Apis",
  },
  API_BINDING: {
    path: "/core-concepts/capturing-data-write",
    searchKey: "Taking Inputs from Widgets",
  },
  DATASOURCE_FORM: {
    path: "/core-concepts/connecting-to-data-sources/connecting-to-databases",
    searchKey: "Connecting to databases",
  },
  LIST_WIDGET: {
    path: "/widget-reference/list",
    searchKey: "List",
  },
  SWITCH_WIDGET: {
    path: "/widget-reference/switch",
    searchKey: "Switch",
  },
  MULTI_SELECT_WIDGET: {
    path: "",
    searchKey: "",
  },
  MULTI_SELECT_WIDGET_V2: {
    path: "",
    searchKey: "",
  },
  RATE_WIDGET: {
    path: "/widget-reference/rate",
    searchKey: "Rate",
  },
  IFRAME_WIDGET: {
    path: "/widget-reference/iframe",
    searchKey: "Iframe",
  },
  DIVIDER_WIDGET: {
    path: "/widget-reference/divider",
    searchKey: "Divider",
  },
  MENU_BUTTON_WIDGET: {
    path: "/widget-reference/menu-button",
    searchKey: "Menu button",
  },
  TREE_MULTI_SELECT_WIDGET: {
    path: "/widget-reference/tree-multi-select",
    searchKey: "Tree Multi Select",
  },
  TREE_SINGLE_SELECT_WIDGET: {
    path: "/widget-reference/tree-single-select",
    searchKey: "Tree Single Select",
  },
  ICON_BUTTON_WIDGET: {
    path: "/widget-reference/icon-button",
    searchKey: "Icon button",
  },
  STATBOX_WIDGET: {
    path: "/widget-reference/statbox",
    searchKey: "Stat Box",
  },
  CHECKBOX_GROUP_WIDGET: {
    path: "/widget-reference/checkbox-group",
    searchKey: "Checkbox Group",
  },
  AUDIO_RECORDER_WIDGET: {
    path: "/widget-reference/audio-recorder",
    searchKey: "Audio Recorder",
  },
  PROGRESSBAR_WIDGET: {
    path: "/widget-reference/progressbar",
    searchKey: "Progress Bar",
  },
  SWITCH_GROUP_WIDGET: {
    path: "/widget-reference/switch-group",
    searchKey: "Switch Group",
  },
  MAP_CHART_WIDGET: {
    path: "/widget-reference/map-chart",
    searchKey: "Map Chart",
  },
};

export const HelpBaseURL = "https://docs.appsmith.com";

export const HELP_MODAL_WIDTH = 170;
